module.exports = __webpack_public_path__ + "img/faculty-kendrea.e1a8aaf7.jpg";